import api, { subUserAuthentication, userAuthentication } from '../Base/Config.js'
import { setSession, getSubUserId } from '../Utils/Common.js'

const userAuthenticationToken = async () => {
    if (getSubUserId()) {
        await api
            .post(subUserAuthentication, {
                subUserId: getSubUserId(),
                token: localStorage.getItem('refresh-token'),
            })
            .then((res) => {
                if (res.data.code === 100) {
                    setSession(res.data.Token)
                } else {
                    window.location.replace('/logout')
                }
            })
    } else {
        await api
            .post(userAuthentication, {
                token: localStorage.getItem('refresh-token'),
            })
            .then((res) => {
                if (res.data.code === 100) {
                    setSession(res.data.token)
                } else {
                    window.location.replace('/logout')
                }
            })
    }
}

export default userAuthenticationToken
